import {
    apiRequest,
    awardExceptionList,
    awardExceptionActive,
    awardExceptionInactive,
} from "../../../../../services/adapters/master/awardExceptionService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", awardExceptionList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", awardExceptionInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", awardExceptionActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository